import { render, staticRenderFns } from "./layouts.vue?vue&type=template&id=f31e55a6&scoped=true"
import script from "./layouts.vue?vue&type=script&lang=js"
export * from "./layouts.vue?vue&type=script&lang=js"
import style0 from "./layouts.vue?vue&type=style&index=0&id=f31e55a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31e55a6",
  null
  
)

export default component.exports